import { ORG_TABS } from './constants';
export type OrgGuideTab = (typeof ORG_TABS)[number];
export const isOrgGuideTab = (tab: string): tab is OrgGuideTab => {
  return ORG_TABS.includes(tab as OrgGuideTab);
};

export type OrgGuideView = 'guide' | 'full-team360-report';
